import { createContext, useContext } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { createUseStyles } from "react-jss";

import ButtonLink from "./ButtonLink";

export const linksContext = createContext(() => {});

const useStyles = createUseStyles(theme => ({
  container: {
    flex: 0,
    padding: `${theme.spacing2} 0`,
    display: "flex",
    backgroundColor: theme.colorBackground,
    color: theme.textColor,
    borderTop: `1px solid ${theme.colorDarkGrey}`,
  },
  mode: {
    margin: `0 ${theme.spacing3}`,
  },
  "@media (max-width: 768px)": {
    mode: {
      margin: `0 ${theme.spacing1}`,
    }
  }
}));

const ModeSelect = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { token } = useParams();
  const history = useHistory();
  const openLinks = useContext(linksContext);

  return (
    <div className={classes.container}>
      <ButtonLink
        icon={["fal", "code-branch"]}
        name="Node editor"
        className={classes.mode}
        onClick={() => history.push(`/editor/${token}`)}
        active={pathname === `/editor/${token}`}
      />
      <ButtonLink
        icon={["fal", "building"]}
        name="Floor plans"
        className={classes.mode}
        onClick={() => history.push(`/editor/${token}/floorplans`)}
        active={pathname === `/editor/${token}/floorplans`}
      />
      <ButtonLink
        icon={["fal", "map-marker-alt"]}
        name="Hotspot intro"
        className={classes.mode}
        onClick={() => history.push(`/editor/${token}/hotspots`)}
        active={pathname === `/editor/${token}/hotspots`}
      />
      <ButtonLink
        icon={["fal", "map-location-dot"]}
        name="Map intro"
        className={classes.mode}
        onClick={() => history.push(`/editor/${token}/mapIntro`)}
        active={pathname === `/editor/${token}/mapIntro`}
      />
      <ButtonLink
        icon={["fal", "link"]}
        name="Links"
        className={classes.mode}
        onClick={openLinks}
      />
      <ButtonLink
        icon={["fal", "play"]}
        name="Autoplay"
        className={classes.mode}
        onClick={() => history.push(`/editor/${token}/autoplay`)}
        active={pathname === `/editor/${token}/autoplay`}
      />
    </div>
  );
};

export default ModeSelect;
